module.exports = __webpack_public_path__ + "static/media/AP3.0f94379e.webp";